module.exports = __webpack_public_path__ + "static/to-you-the-people-a21a7a82a2c92f8f3defea1d5baa5f61.webp";